import React from "react";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Modal, ModalBody } from "reactstrap";
import axios from "axios";
import config from "../config";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Player } from 'video-react';
// import HLSSource from '../HLSSource';
// import '../assets/video-react.css'
// import VideoPlayer from '../assets/video-js/video'
// import VideoPlayer from '../components/Video'
import VideoPlayer from "../components/Live";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import socketIOClient from "socket.io-client";
import ReactTooltip from "react-tooltip";
import "../styles/layout.css";
import "./Studio.css";

const socket = socketIOClient("https://socket-io.i-iptv.com");

library.add(fas);

const optionToast = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

class Studio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalConfirm: false,
      modalDelete: false,
      deleteSubmitting: false,
      studios: [],
      playerSource: "",
      stream_url: "",
      value: false,
      valueShow: false,
      title: "",
      desc: "",
      isrecording: false,
      isconnect: false,
      disable: false,
      viewer: 0,
      copyServerStatus: false,
      copyKeyStatus: false,
      copyUrlStatus: false,
      copyEmbedStatus: false,
      copyStreamOutStatus: false,
      refreshStream: "",
    };

    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.handleChangeDesc = this.handleChangeDesc.bind(this);
  }

  handleChangeSwitch = () => {
    this.setState((prev) => ({ value: !prev.value }));
  };

  handleChangeDesc(event) {
    this.setState({
      desc: event.target.value,
    });
  }

  handleChangeTitle(event) {
    this.setState({
      title: event.target.value,
    });
  }

  toggle = () => {
    this.feedStudio();
    // console.log(data);
    this.setState({
      modal: !this.state.modal,
    });
  };

  toggleConfirm = () => {
    // console.log(data);
    this.setState({
      modalConfirm: !this.state.modalConfirm,
    });
  };

  toggleDelete = () => {
    if (this.state.deleteSubmitting) return;
    this.setState({
      modalDelete: !this.state.modalDelete,
    });
  };

  deleteChannel = () => {
    if (this.state.deleteSubmitting) return;

    this.setState({ deleteSubmitting: true });

    axios
      .post(config.host + "/api/v1/live/stream/delete", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
      })
      .then((res) => {
        if (res.data.status === "deleted" || res.data.code === "200") {
          toast.success("Channel deleted successfully", optionToast);
          this.props.history.push("/live-streams");
          return;
        }

        toast.error("Failed to delete channel", optionToast);
        this.setState({ deleteSubmitting: false });
      })
      .catch(() => {
        toast.error("Failed to delete channel", optionToast);
        this.setState({ deleteSubmitting: false });
      });
  };

  componentDidMount = () => {
    this.feedStudio();
    // this.previewLive()
    axios
      .post(config.host + "/api/v1/live/stream/detail", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
      })
      .then((res) => {
        // console.log(res);
        var getStreamURL = res.data.result.stream_url;
        var smilName = getStreamURL.split("/");
        var streamName = smilName[4].split(".");
        var FinalName = streamName[0].split(":");

        const socketKey =
          FinalName.length === 1 ? FinalName[0] : FinalName[1];
        if (!socketKey) return;

        this.studioSocketKey = socketKey;
        this.studioSocketHandler = (entry) => {
          if (entry && entry.reload === "true") {
            // Player handles stream reload itself; only refresh metadata
            this.feedStudio();
            return;
          }
          // CCU updates: update viewer count only (do not re-fetch studio)
          if (entry && entry.ccu != null) {
            this.setState({ viewer: entry.ccu });
          }
        };
        socket.on(socketKey, this.studioSocketHandler);
      })
      .catch((err) => {});
  };

  componentWillUnmount = () => {
    if (this.studioSocketHandler && this.studioSocketKey) {
      socket.off(this.studioSocketKey, this.studioSocketHandler);
    }
  };

  Live = () => (
    <div className="overlay-live">
      <span className="label-live">Live</span>
    </div>
  );

  feedStudio = () => {
    axios
      .post(config.host + "/api/v1/live/stream/detail", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
      })
      .then((res) => {
        const result = res.data.result || {};

        this.setState({
          studios: result,
          title: result.user_title,
          desc: result.user_desc,
          viewer: Number.isFinite(Number(result.ccu)) ? Number(result.ccu) : 0,
        });

        if (result.isrecording === "true") {
          this.setState({
            isrecording: true,
          });
        } else {
          this.setState({
            isrecording: false,
          });
        }

        if (res.data.result.isconnect === "true") {
          this.setState({
            disable: false,
            isconnect: true,
          });
        } else {
          this.setState({
            disable: true,
            isconnect: false,
          });
        }

        if (
          res.data.result.option === "auto" ||
          res.data.result.option === "none"
        ) {
          this.setState({
            disable: true,
          });
        } else {
          this.setState({
            disable: false,
          });
        }

        if (res.data.result.user_views === "true") {
          this.setState({
            value: true,
            valueShow: true,
          });
        } else {
          this.setState({
            value: false,
            valueShow: false,
          });
        }
      })
      .catch((err) => {});
  };

  updateChannel = () => {
    axios
      .post(config.host + "/api/v1/live/stream/update", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
        user_title: this.state.title,
        user_desc: this.state.desc,
        user_views: this.state.value,
      })
      .then((res) => {
        if (res.data.code === "200") {
          toast.success("Update Live channel successfully !", optionToast);
        }
        this.toggle();
        this.feedStudio();
      })
      .catch((err) => {});
  };

  previewLive = () => {
    axios
      .post(config.host + "/api/v1/live/stream/preview", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
      })
      .then((res) => {
        this.setState({
          playerSource: res.data.stream_url,
        });
      })
      .catch((err) => {});
  };

  recordStream = (e, data) => {
    if (data === "true") {
      axios
        .post(config.host + "/api/v1/recorder/manual", {
          id: this.props.match.params.id,
          userid: localStorage.StudioUserID,
          action: "start",
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.setState({
              disable: true,
            });
            setTimeout(() => {
              // this.feedStudio()
              this.setState({
                isrecording: true,
                disable: false,
              });
              toast.success("Start Recorder Successfully!", optionToast);
              console.log("Recording");
            }, 3000);
            // this.setState({
            //   isrecording: 'true'
            // })
            // this.feedStudio()
            // toast.success('Start Recorder Successfully!', optionToast);
            // console.log('Recording');
          }
        })
        .catch((err) => {
          toast.error("Start Recorder has not working!", optionToast);
        });
    } else {
      this.setState({
        modalConfirm: !this.state.modalConfirm,
      });
    }
  };

  stopRecord = () => {
    axios
      .post(config.host + "/api/v1/recorder/manual", {
        id: this.props.match.params.id,
        userid: localStorage.StudioUserID,
        action: "stop",
      })
      .then((res) => {
        if (res.data.status === "success") {
          this.toggleConfirm();
          this.setState({
            disable: true,
          });
          setTimeout(() => {
            // this.feedStudio()
            this.setState({
              isrecording: false,
              disable: false,
            });
            toast.success("Stop Recorder Successfully!", optionToast);
            console.log("Stop");
          }, 3000);
          // this.setState({
          //   isrecording: 'false'
          // })
          // this.feedStudio()
          // toast.success('Stop Recorder Successfully!', optionToast);
          // console.log('Stop');
        }
      })
      .catch((err) => {
        toast.error("Stop Recorder has not working!", optionToast);
      });
  };

  serverCopy = () => {
    // toast.success('Copied to clipboard !', optionToast);
    this.setState({ copyServerStatus: !this.state.copyServerStatus });
    var copyText = document.getElementById("server");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setTimeout(() => {
      this.setState({ copyServerStatus: !this.state.copyServerStatus });
    }, 2000);
  };

  streamkeyCopy = () => {
    // toast.success('Copied to clipboard !', optionToast);
    this.setState({ copyKeyStatus: !this.state.copyKeyStatus });
    var copyText = document.getElementById("streamkey_copy");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setTimeout(() => {
      this.setState({ copyKeyStatus: !this.state.copyKeyStatus });
    }, 2000);
  };

  playbackCopy = () => {
    // toast.success('Copied to clipboard !', optionToast);
    this.setState({ copyUrlStatus: !this.state.copyUrlStatus });
    var copyText = document.getElementById("restream");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setTimeout(() => {
      this.setState({ copyUrlStatus: !this.state.copyUrlStatus });
    }, 2000);
  };

  streamOutCopy = () => {
    this.setState({ copyStreamOutStatus: !this.state.copyStreamOutStatus });
    var copyText = document.getElementById("stream_out");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setTimeout(() => {
      this.setState({ copyStreamOutStatus: !this.state.copyStreamOutStatus });
    }, 2000);
  };

  embedCopy = () => {
    // toast.success('Copied to clipboard !', optionToast);
    this.setState({ copyEmbedStatus: !this.state.copyEmbedStatus });
    var copyText = document.getElementById("embed");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setTimeout(() => {
      this.setState({ copyEmbedStatus: !this.state.copyEmbedStatus });
    }, 2000);
  };

  testPlayer = () => {
    window.open(
      window.location.protocol +
        "//" +
        window.location.hostname +
        ":" +
        window.location.port +
        "/test-stream/" +
        this.props.match.params.id,
    );
  };

  goBack = () => {
    if (this.props.history.length > 1) {
      this.props.history.goBack();
    } else {
      this.props.history.push("/home");
    }
  };

  render() {
    const videoJsOptions = {
      autoplay: true,
      muted: false,
      controls: true,
      fluid: true,
      responsive: true,
      liveui: true,
      controlBar: {
        volumePanel: {
          inline: true,
        },
        pictureInPictureToggle: true,
      },
      // Do not preload demo HLS — player loads real stream_url itself
      sources: [],
    };

    return (
      <div className="app-shell">
        <Navbar />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ReactTooltip
          id="custom-color-no-arrow"
          className="custom-color-no-arrow"
          effect="solid"
        />

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          centered
          backdrop="static"
          className="studio-edit-modal"
          contentClassName="studio-edit-modal__content"
        >
          <div className="studio-edit-modal__header">
            <h3 className="studio-edit-modal__title">Edit Channel</h3>
            <button
              type="button"
              className="studio-edit-modal__close-btn"
              onClick={this.toggle}
              aria-label="Close"
            >
              <FontAwesomeIcon icon={["fas", "times"]} />
            </button>
          </div>
          <ModalBody className="studio-edit-modal__body">
            <form>
              <div className="form-group">
                <label className="form-label text-left">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.title}
                  onChange={this.handleChangeTitle}
                />
              </div>
              <div className="form-group">
                <label className="form-label text-left">Description</label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={this.state.desc}
                  onChange={this.handleChangeDesc}
                />
              </div>
              <div className="studio-edit-modal__viewer">
                <div className="studio-edit-modal__viewer-label">
                  <span>Viewer display</span>
                  {this.state.value ? (
                    <span className="studio-badge studio-badge--on">
                      Enabled
                    </span>
                  ) : (
                    <span className="studio-badge studio-badge--off">
                      Disabled
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={this.state.value}
                  className={`studio-edit-modal__switch${this.state.value ? " is-on" : ""}`}
                  onClick={this.handleChangeSwitch}
                >
                  <span className="studio-edit-modal__switch-thumb" />
                </button>
              </div>
            </form>
          </ModalBody>
          <div className="studio-edit-modal__footer">
            <button
              type="button"
              className="studio-modal-btn studio-modal-btn--ghost"
              onClick={this.toggle}
            >
              Cancel
            </button>
            <button
              type="button"
              className="studio-modal-btn studio-modal-btn--primary"
              onClick={this.updateChannel}
            >
              Update
            </button>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.modalConfirm}
          toggle={this.toggleConfirm}
          centered
          backdrop="static"
          className="studio-confirm-modal"
          contentClassName="studio-confirm-modal__content"
        >
          <ModalBody className="studio-confirm-modal__body">
            <div className="studio-confirm-modal__icon">
              <FontAwesomeIcon icon={["fas", "stop-circle"]} />
            </div>
            <h3 className="studio-confirm-modal__title">Stop recording?</h3>
            <p className="studio-confirm-modal__text">
              Are you sure you want to stop recording{" "}
              <strong>{this.state.studios.name}</strong>?
            </p>
            <div className="studio-confirm-modal__actions">
              <button
                type="button"
                className="studio-modal-btn studio-modal-btn--ghost"
                onClick={this.toggleConfirm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="studio-modal-btn studio-modal-btn--danger"
                onClick={this.stopRecord}
              >
                Stop
              </button>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modalDelete}
          toggle={this.toggleDelete}
          centered
          backdrop="static"
          className="studio-confirm-modal"
          contentClassName="studio-confirm-modal__content"
        >
          <ModalBody className="studio-confirm-modal__body">
            <div className="studio-confirm-modal__icon studio-confirm-modal__icon--danger">
              <FontAwesomeIcon icon={["fas", "trash"]} />
            </div>
            <h3 className="studio-confirm-modal__title">Delete channel?</h3>
            <p className="studio-confirm-modal__text">
              Are you sure you want to delete{" "}
              <strong>{this.state.studios.name}</strong>? This action cannot be
              undone.
            </p>
            <div className="studio-confirm-modal__actions">
              <button
                type="button"
                className="studio-modal-btn studio-modal-btn--ghost"
                onClick={this.toggleDelete}
                disabled={this.state.deleteSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="studio-modal-btn studio-modal-btn--danger"
                onClick={this.deleteChannel}
                disabled={this.state.deleteSubmitting}
              >
                {this.state.deleteSubmitting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </ModalBody>
        </Modal>

        <main className="app-main">
          <div className="studio-page">
            <div className="studio-page__top">
              <div className="studio-page__top-left">
                <button
                  type="button"
                  className="studio-back-btn"
                  onClick={this.goBack}
                  aria-label="Back"
                >
                  <FontAwesomeIcon icon={["fas", "arrow-left"]} />
                  Back
                </button>
              </div>
              <div className="studio-page__top-actions">
                <button
                  type="button"
                  onClick={this.testPlayer}
                  className="studio-test-btn"
                >
                  <FontAwesomeIcon
                    icon={["fas", "play"]}
                    style={{ marginRight: "0.4rem" }}
                  />
                  Test Player
                </button>
                <button
                  type="button"
                  className="studio-edit-btn"
                  onClick={this.toggle}
                >
                  <FontAwesomeIcon
                    icon={["fas", "edit"]}
                    style={{ marginRight: "0.4rem" }}
                  />
                  Edit
                </button>
                <button
                  type="button"
                  className="studio-delete-btn"
                  onClick={this.toggleDelete}
                >
                  <FontAwesomeIcon
                    icon={["fas", "trash"]}
                    style={{ marginRight: "0.4rem" }}
                  />
                  Delete
                </button>
              </div>
            </div>

            <div className="studio-card">
              <div className="studio-hero">
                <div className="studio-player-wrap">
                  <VideoPlayer
                    id="video-area"
                    type={this.state.refreshStream}
                    src={this.state.playerSource}
                    {...videoJsOptions}
                  />
                </div>

                <div className="studio-meta">
                  <div className="studio-info-card">
                    <div className="studio-meta__grid">
                      <div className="studio-meta__field">
                        <label>Title</label>
                        <p>{this.state.title}</p>
                      </div>
                      <div className="studio-meta__field">
                        <label>Description</label>
                        <p>{this.state.desc || "—"}</p>
                      </div>
                      <div className="studio-meta__field">
                        <label>Viewers</label>
                        <p>
                          {this.state.valueShow ? (
                            this.state.viewer
                          ) : (
                            <span className="studio-badge studio-badge--off">
                              Disabled
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="studio-status-card">
                    <div className="studio-status-bar">
                      <div className="studio-status-item">
                        <span className="studio-status-item__label">
                          Source
                        </span>
                        <span
                          className={`studio-status-item__value ${this.state.isconnect ? "is-online" : "is-offline"}`}
                        >
                          <FontAwesomeIcon icon={["fas", "video"]} />
                          {this.state.isconnect ? "Online" : "Offline"}
                        </span>
                      </div>
                      <div className="studio-status-item">
                        <span className="studio-status-item__label">
                          Recorder
                        </span>
                        <span
                          className={`studio-status-item__value ${this.state.isrecording ? "is-recording" : "is-idle"}`}
                        >
                          {this.state.isrecording ? (
                            <>
                              <span className="stream-card__rec-dot" />
                              Recording
                            </>
                          ) : (
                            <>
                              <span className="studio-status-dot studio-status-dot--idle" />
                              Idle
                            </>
                          )}
                        </span>
                      </div>
                      <div className="studio-status-item">
                        <span className="studio-status-item__label">
                          Actions
                        </span>
                        <span className="studio-status-item__value">
                          {this.state.isrecording ? (
                            <button
                              type="button"
                              className="studio-rec-btn studio-rec-btn--stop"
                              onClick={(e) => this.recordStream(e, "false")}
                              disabled={this.state.disable}
                              data-for="custom-color-no-arrow"
                              data-tip="Stop Record"
                            >
                              <span className="studio-rec-btn__stop" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="studio-rec-btn studio-rec-btn--start"
                              onClick={(e) => this.recordStream(e, "true")}
                              disabled={this.state.disable}
                              data-for="custom-color-no-arrow"
                              data-tip="Start Record"
                            >
                              <span className="studio-rec-btn__inner" />
                            </button>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="studio-card">
              <div className="studio-card__header">
                <h2 className="studio-card__title">Ingest Stream</h2>
              </div>
              <div className="studio-ingest">
                <div className="studio-ingest__grid">
                  <div className="studio-ingest__col">
                    <div className="studio-field">
                      <label>Server</label>
                      <div className="studio-copy-row">
                        <div className="studio-copy-row__input">
                          <input
                            className="form-control"
                            type="text"
                            id="server"
                            readOnly
                            value={this.state.studios.server || ""}
                          />
                        </div>
                        <div className="studio-copy-btn-wrap">
                          <button
                            type="button"
                            onClick={this.serverCopy}
                            className={`studio-copy-btn ${this.state.copyServerStatus ? "studio-copy-btn--copied" : ""}`}
                          >
                            {this.state.copyServerStatus ? "Copied!" : "Copy"}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="studio-field">
                      <label>Stream Key</label>
                      <div className="studio-copy-row">
                        <div className="studio-copy-row__input">
                          <input
                            className="form-control"
                            type="text"
                            id="streamkey_copy"
                            value={this.state.studios.streamkey || ""}
                            readOnly
                          />
                        </div>
                        <div className="studio-copy-btn-wrap">
                          <button
                            type="button"
                            onClick={this.streamkeyCopy}
                            className={`studio-copy-btn ${this.state.copyKeyStatus ? "studio-copy-btn--copied" : ""}`}
                          >
                            {this.state.copyKeyStatus ? "Copied!" : "Copy"}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="studio-field">
                      <label>Stream Out</label>
                      <div className="studio-copy-row">
                        <div className="studio-copy-row__input">
                          <input
                            className="form-control"
                            type="text"
                            id="stream_out"
                            readOnly
                            value={this.state.studios.stream_output || ""}
                          />
                        </div>
                        <div className="studio-copy-btn-wrap">
                          <button
                            type="button"
                            onClick={this.streamOutCopy}
                            className={`studio-copy-btn ${this.state.copyStreamOutStatus ? "studio-copy-btn--copied" : ""}`}
                          >
                            {this.state.copyStreamOutStatus ? "Copied!" : "Copy"}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="studio-field">
                      <label>HLS Playback URL</label>
                      <div className="studio-copy-row">
                        <div className="studio-copy-row__input">
                          <input
                            className="form-control"
                            type="text"
                            id="restream"
                            readOnly
                            value={this.state.studios.stream_url || ""}
                          />
                        </div>
                        <div className="studio-copy-btn-wrap">
                          <button
                            type="button"
                            onClick={this.playbackCopy}
                            className={`studio-copy-btn ${this.state.copyUrlStatus ? "studio-copy-btn--copied" : ""}`}
                          >
                            {this.state.copyUrlStatus ? "Copied!" : "Copy"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="studio-ingest__col studio-ingest__col--embed">
                    <div className="studio-field studio-field--embed">
                      <label>Embed Player</label>
                      <div className="studio-copy-row studio-copy-row--embed">
                        <div className="studio-copy-row__input">
                          <textarea
                            id="embed"
                            className="form-control"
                            value={this.state.studios.embed_player || ""}
                            readOnly
                          />
                        </div>
                        <div className="studio-copy-btn-wrap">
                          <button
                            type="button"
                            onClick={this.embedCopy}
                            className={`studio-copy-btn ${this.state.copyEmbedStatus ? "studio-copy-btn--copied" : ""}`}
                          >
                            {this.state.copyEmbedStatus ? "Copied!" : "Copy"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default Studio;
